import tableIcon from "icons/duotone/table.svg";
import cardIcon from "icons/duotone/list.svg";
import shelfIcon from "icons/duotone/shelves.svg";
import { ViewLink } from "./ViewLink";
import { LetterbookSettingType } from "features/Letterbooks/types";

interface LetterbookOptions {
  settings: LetterbookSettingType;
}

export default function ViewLinks({
  settings,
}: LetterbookOptions) {
  return (
    <div className="flex flex-row space-x-2">
      <ViewLink
        view="table"
        icon={tableIcon}
        title="Table"
        settings={settings}
      />
      <ViewLink view="card" icon={cardIcon} title="Card" settings={settings} />
      <ViewLink
        view="shelf"
        icon={shelfIcon}
        title="Shelf"
        settings={settings}
      />
    </div>
  );
}
